// components/Navbar/Navbar.jsx
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import './css/navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  // Handle scroll effect for navbar background
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Toggle Menu Function
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Close menu when a link is clicked
  const closeMenu = () => {
    setIsOpen(false);
  };

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isOpen]);

  return (
    <nav className={`navbar-custom ${scrolled ? 'scrolled' : ''}`} dir="rtl">
      <div className="container">
        <div className="navbar-content">
          
          {/* Hamburger Button (Visible on Mobile) */}
          <div className="navbar-toggle" onClick={toggleMenu}>
            <span className={`bar ${isOpen ? 'open' : ''}`}></span>
            <span className={`bar ${isOpen ? 'open' : ''}`}></span>
            <span className={`bar ${isOpen ? 'open' : ''}`}></span>
          </div>

          {/* Logo Area */}
          <motion.div 
            className="navbar-brand"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Link to="/" onClick={closeMenu}>
              <span className="brand-text">  موقع الدكتورة نهى الحازمي لخدمات البحث العلمي   </span>
            </Link>
          </motion.div>

          {/* Desktop Navigation Links (Hidden on Mobile) */}
          <div className="navbar-links d-none d-md-flex">
            <Link to="/about" className="nav-link">من أنا؟</Link>
            <Link to="/services" className="nav-link">الخدمات والأسعار</Link>
            <Link to="/reviews" className="nav-link">آراء العملاء</Link>
            <Link to="/blog" className="nav-link">المدونة</Link>
            <Link to="/products" className="nav-link">المنتجات الرقمية</Link>
            <Link to="/faq" className="nav-link">الأسئلة الشائعة</Link>
          </div>

          {/* CTA Button (Desktop) */}
          <motion.div 
            className="navbar-cta d-none d-md-block"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <Link to="/booking" className="btn-custom">احجزي استشارة</Link>
          </motion.div>

        </div>
      </div>

      {/* Mobile Menu Overlay & Drawer */}
      <AnimatePresence>
        {isOpen && (
          <>
            {/* Backdrop (Dark overlay) */}
            <motion.div 
              className="mobile-backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={closeMenu}
            />

            {/* Sliding Drawer (From Right) */}
            <motion.div 
              className="mobile-menu-container"
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
            >
              <div className="mobile-header">
                <button className="close-btn" onClick={closeMenu}>&times;</button>
              </div>

              <div className="mobile-links">
                <Link to="/" className="mobile-link" onClick={closeMenu}>الرئيسية</Link>
                <Link to="/about" className="mobile-link" onClick={closeMenu}>من أنا؟</Link>
                <Link to="/services" className="mobile-link" onClick={closeMenu}>الخدمات والأسعار</Link>
                <Link to="/reviews" className="mobile-link" onClick={closeMenu}>آراء العملاء</Link>
                <Link to="/blog" className="mobile-link" onClick={closeMenu}>المدونة</Link>
                <Link to="/products" className="mobile-link" onClick={closeMenu}>المنتجات الرقمية</Link>
                <Link to="/faq" className="mobile-link" onClick={closeMenu}>الأسئلة الشائعة</Link>
                
                <div className="mobile-cta">
                  <Link to="/booking" className="btn-custom" onClick={closeMenu}>احجزي استشارة</Link>
                </div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;